// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foreground {\n  background: #c8c8c8;\n}\n.background {\n  background: white;\n}\n", ""]);
// Exports
module.exports = exports;
